// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2567":"fe3d9a1c17ae0334","2715":"b8a11a98cbb6bfb5","2722":"0f79dbe9ea1e3c77","3945":"5a0fa7f7976aea5b","7584":"a5f0c83ca3a862b0"}[chunkId] + ".css";
};